export default __webpack_public_path__ + "translate-chrome-mobile-1.png";